import { useAuth } from "react-oidc-context";

/**
 * Browser-tab title in Outlook's "App - Person" form, e.g.
 * "Mail - Hemant Kumar", so a user with several accounts open can
 * tell the tabs apart. Uses the same name order as the top bar; falls back to
 * the bare app name until the profile is available.
 */
export function useAppTitle(app: string): string {
    const auth = useAuth();
    const profile = auth.user?.profile;
    const name = (profile?.name ?? profile?.preferred_username ?? profile?.email ?? "").trim();
    return name ? `${app} - ${name}` : app;
}
